import { REACT_APP_APPLICATION_PROFILE } from './appConfig';
import norkartIdJs from 'auth';

export default function Get(dataUri) {

    var returnedToken = norkartIdJs.getToken();
    var httpMethod = 'GET';    

    return new Promise((resolve, reject) => {
        returnedToken.then((token) => {
            fetch(dataUri, getFetchSettings(httpMethod, token))            
              .then(res => res.json())
              .then(json => {                
                  var resultat = json
                  resultat != null && resultat !== {} ? resolve(json) : reject('Uthenting av data fra ' + dataUri + ' feilet')
              })
              .catch(error => {
                console.error(error);                  
                reject('Feilet med error: ' + error)                  
            })
        })
    })
}

function getFetchSettings(httpMethod, token) {
    return {
        method: httpMethod,
        headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json',          
            'Authorization': 'Bearer ' + token,
            'X-WAAPI-PROFILE': REACT_APP_APPLICATION_PROFILE          
        }
    }
} 